module.exports = __webpack_public_path__ + "static/media/comercial.bbcf3eed.jpg";